<template>
  <div class="emb-payment-wrap">
    <emb-page-title :heading="bannerSection.Title" :image="bannerSection.Banner_Image"></emb-page-title>
    <div class="emb-payment-content section-gap overflow-x-hidden">
      <v-container grid-list-xl py-0>
        <template v-if="invoiceData.products.length > 0">
          <!-- <emb-sidebar-panel class="mb-12"></emb-sidebar-panel> -->
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <shipping-address
                :addressSection="addressSection"
                @changeStepOneForm="enableStepOneForm"
              ></shipping-address>
            </v-expansion-panel>
            <!-- <v-expansion-panel :disabled="!stepOneFormValid" :class="{'contracted': !stepOneFormValid}">
							<promo-codes @changePanel="changePanelValue"></promo-codes>
            </v-expansion-panel>-->
            <v-expansion-panel
              :disabled="!stepOneFormValid"
              :class="{'contracted': !stepOneFormValid}"
            >
              <payment-option :paymentPage="paymentSection"></payment-option>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-else>
          <div class="text-center">
            <div class="mb-6">
              <img alt="cart-empty" height="128" src="/static/images/empty-cart.png" width="128" />
            </div>
            <h4>Your Shopping Bag is empty.</h4>
            <router-link class="primary--text" to="/">Go to Shopping</router-link>
          </div>
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
import gettingRestClientObject from "../../../services/utils/cms-helper";

import ShippingAddress from "./Component/ShippingAddress";
// import PromoCodes from './Component/PromoCodes'
import PaymentOption from "./Component/PaymentOption";
import { mapGetters } from "vuex";

export default {
  mounted() {
    var queryParams = this.$route.query;
    if (queryParams !== undefined && queryParams.payment == "success") {
      this.$router.push({ path: "/checkout/final-receipt" });
      // this.$store.dispatch("addPaymentInfo", this.selectedPayment);
    }
  },
  data() {
    return {
      stepOneFormValid: false,
      expansionPanel: [0],
      addressSection: {},
      bannerSection: {},
      paymentSection: {},
    };
  },
  components: {
    shippingAddress: ShippingAddress,
    // promoCodes:PromoCodes,
    paymentOption: PaymentOption,
  },
  created() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getData();
  },

  computed: {
    ...mapGetters(["invoiceData", "selectedLocale"]),
    panel: {
      get() {
        return this.expansionPanel;
      },
      set(val) {
        if (val.includes(0)) {
          this.expansionPanel = [0];
          this.stepOneFormValid = false;
        } else if (val.includes(1) && this.expansionPanel != 1) {
          this.expansionPanel = [1];
        } else if (val.includes(2)) {
          this.expansionPanel = [2];
        } else {
          this.expansionPanel = [];
        }
      },
    },
  },
  watch: {
    selectedLocale() {
      this.getData();
    },
  },
  methods: {
    enableStepOneForm() {
      this.stepOneFormValid = true;
      this.expansionPanel = [1];
    },
    getData() {
      var self = this;

      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "26 Payment/26 Payment/26 Payment.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var addressArea = self.cmsRequestFunctions.pluck(
              "Billing_Address_Section",
              res.area_List
            );
            self.addressSection = self.cmsRequestFunctions.getAllMapData(
              addressArea[0].component
            );

            var bannerArea = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );
            self.bannerSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );

            var paymentArea = self.cmsRequestFunctions.pluck(
              "Payment_Section",
              res.area_List
            );
            self.paymentSection = self.cmsRequestFunctions.getAllMapData(
              paymentArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>
